import React, {useEffect, useState} from 'react';
import {
   Image,
   SafeAreaView,
   StyleSheet,
   Text,
   View,
   TouchableOpacity,
   Dimensions,
   Platform,
   NativeModules,
} from 'react-native';
import {
   All,
   ALLCOURSE,
   appBackground,
   gray,
   HIDELEGACY,
   INSESSION,
   primaryColor800,
   primaryColor900,
   primaryState700,
   RECENT,
   VALID,
   white,
   FONT_FAMILY_REGULAR,
   IBTRecords,
   primaryColor500,
   ExternalRecords,
   ThirdPartyRecords,
   TrainingOJTRecords,
   isWeb,
   isWindows,
   TrainingAllRecords,
   REFRESH_DASHBOARD,
   BUTTON_HOVER_COLOR,
   isHoverEnabled,
   WHITE_ICON_HOVER_TINT_COLOR,
   BACK_ARROW_HOVER_TINT_COLOR,
   TabView_HOVER_COLOR,
   isiOS,
} from '../../utils/utils';
import SearchView from './SearchView';
import TabView from './TabView';
import {PopoverLandscape} from '../../utils/popoverView';
import {MyTrainingPopup} from '../../utils/MyTrainingPopup';
import {useSelector} from 'react-redux';
import {
   getIsTabletPortrait,
   getShowLandscapeMsg,
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import logger from '../../utils/logger';
import {Popup} from '../../components/popup';
import {isTablet} from 'react-device-detect';
import RefreshDashBoardView from '../../utils/refreshDashboard';

const DashboardHeaderLandsacap = props => {
   const [selectedFilter, setSelectedFilter] = useState(ALLCOURSE);
   const [selectedRecordFilter, setSelectedRecordFilter] = useState(
      props.selectedTab,
   );
   const [selectedTrainingRecord, setSelectedTrainingRecord] = useState(
      props.trainingFilleter,
   );

   const [anchorView, setAnchorView] = useState({x: 0, y: 100});
   const [myTraingDrpDownWidth, setTraingDrpDownWidth] = useState(0);
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const [popoverVisible, setPopoverVisible] = useState(false);
   const isIOS = Platform.OS === 'ios';
   const [windowsPopoverVisible, setWindowsPopoverVisible] = useState(false);
   const myRef = React.useRef(null);
   const isMacos = Platform.OS === 'macos';

   const [validOrientationWeb, setValidOrientationWeb] = useState(true);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const showLandscapeMsg = useSelector(getShowLandscapeMsg);
   const isTabletPortraitMode = useSelector(getIsTabletPortrait);
   useEffect(() => {
      if (isWeb) {
         setValidOrientationWeb(
            !(
               showLandscapeMsg &&
               (isLandscapeSmallWebView || isTabletPortraitMode)
            ),
         );
      }
   }, [isLandscapeSmallWebView, showLandscapeMsg, isTabletPortraitMode]);

   useEffect(() => {
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      const subscription = Dimensions.addEventListener('change', handleResize);
      return () => {
         subscription.remove();
      };
   }, []);

   const handleLayout = event => {
      const {x, y, width, height} = event.nativeEvent.layout;
      setTraingDrpDownWidth(width);
      setAnchorView({
         x: x,
         y: isIOS ? y + 120 : y + 100,
      });
   };

   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isHover, setHover] = React.useState(false);
   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     maxHeight: isLandscapeMode ? '72vh' : null,
                     flexWrap: isLandscapeMode ? 'wrap' : null,
                  },
               }),
            },
         ]}>
         <View style={styles.headerTopBackground}>
            {props.title === 'My Training' ? (
               <TouchableOpacity
                  ref={myRef}
                  onLayout={handleLayout}
                  onMouseEnter={() => {
                     setHover(true);
                  }}
                  onMouseLeave={() => {
                     setHover(false);
                  }}
                  onPress={event => {
                     if (!isMacos) {
                        if (Platform.OS === 'windows') {
                           setWindowsPopoverVisible(true);
                        } else {
                           setPopoverVisible(true);
                        }
                     } else {
                        NativeModules.PopoverModule.showList(
                           [
                              TrainingAllRecords,
                              IBTRecords,
                              ExternalRecords,
                              ThirdPartyRecords,
                              TrainingOJTRecords,
                           ],
                           0,
                           event.nativeEvent.pageY + 15,
                           selectedItem => {
                              setSelectedTrainingRecord(selectedItem);
                              props.filterMytrainingData(selectedItem);
                           },
                        );
                     }
                  }}
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor:
                           isHover && isHoverEnabled
                              ? TabView_HOVER_COLOR
                              : primaryColor500,
                        paddingHorizontal: 10,
                        paddingVertical: 8,
                        borderRadius: 4,
                        ...Platform.select({web: {paddingVertical: 8}}),
                     }}>
                     <Image
                        source={props.icon}
                        tintColor={white}
                        style={{
                           width: 18,
                           height: 18,
                           tintColor: white,
                        }}
                     />
                     <Text
                        style={{
                           textAlignVertical: 'center',
                           color: white,
                           fontSize: 16,
                           marginLeft: 10,
                           fontWeight: '500',
                           fontFamily: FONT_FAMILY_REGULAR,
                           marginRight: 8,
                           ...Platform.select({web: {marginTop: -2}}),
                        }}>
                        {selectedTrainingRecord}
                     </Text>

                     <Image
                        source={require('../../assets/down_arrow.png')}
                        style={{
                           marginStart: 10,
                           width: 24,
                           height: 18,
                           alignSelf: 'center',
                           tintColor: white,
                           ...Platform.select({web: {width: 24, height: 18}}),
                        }}
                     />
                  </View>
               </TouchableOpacity>
            ) : (
               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     paddingHorizontal: null,
                     paddingVertical: 5,
                     borderRadius: 4,
                     flex: 1,
                  }}>
                  <Image
                     source={props.icon}
                     style={{
                        width: 18,
                        height: 18,
                        marginTop: props.title === 'Record Details' ? 3 : null,
                        tintColor: white,
                        alignSelf: 'center',
                     }}
                  />
                  <Text
                     style={{
                        flex: 1,
                        textAlignVertical: 'center',
                        color: white,
                        fontSize: 20,
                        marginLeft: 10,
                        fontWeight: '500',
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginRight: 8,
                     }}>
                     {props.title}
                  </Text>
               </View>
            )}
            {props.showCourses ? (
               <Text
                  style={{
                     color: white,
                     fontSize: 10,
                     fontWeight: isiOS ? null : '600',
                     marginEnd: 8,
                     fontFamily: isiOS ? 'Helvetica Neue' : FONT_FAMILY_REGULAR,
                     fontStyle: 'italic',
                     textAlign: 'right',
                     ...Platform.select({
                        web: {
                           minWidth: isLandscapeMode ? 50 : null,
                           width: window.innerWidth > 545 ? 150 : 50,
                        },
                     }),
                  }}>
                  {props.title === 'Dashboard'
                     ? `${props.showEnrolledCourses?.length} Enrolled courses.`
                     : `${
                          typeof props.trainigRecords === 'undefined'
                             ? 0
                             : props.trainigRecords
                       } Records`}
               </Text>
            ) : null}
            {props.showSearchView ? (
               <SearchView
                  onClearText={() => {
                     props.onClearText();
                  }}
                  onSearch={text => {
                     props.onSearch(text);
                  }}
               />
            ) : null}
         </View>
         {props.showFooter ? (
            <View
               style={[
                  styles.headerBottomBackground,
                  {
                     height:
                        Platform.OS == 'web' ? 48 : isLandscapeMode ? 48 : 32,
                  },
               ]}>
               <Text
                  style={{
                     flex: 1,
                     color: '#6E8EFF',
                     fontSize: 16,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  {props.subtitle}
               </Text>
               {props.showRecordTabs ? (
                  <View style={{flexDirection: 'row'}}>
                     <TouchableOpacity
                        onPress={() => {
                           setSelectedRecordFilter(VALID);
                           props.onFilterClick(VALID);
                        }}>
                        <TabView
                           isSelected={
                              selectedRecordFilter === VALID ? true : false
                           }
                           value="Valid"
                        />
                     </TouchableOpacity>
                     <TouchableOpacity
                        onPress={() => {
                           setSelectedRecordFilter(All);
                           props.onFilterClick(All);
                        }}>
                        <TabView
                           isSelected={
                              selectedRecordFilter === All ? true : false
                           }
                           value="All"
                        />
                     </TouchableOpacity>
                  </View>
               ) : null}
               {props.showFilterTabs ? (
                  <View style={{flexDirection: 'row', height: 32}}>
                     {/* @All Course */}
                     <TouchableOpacity
                        onPress={() => {
                           setSelectedFilter(ALLCOURSE);
                           props.onFilterClick(ALLCOURSE);
                        }}>
                        <TabView
                           isSelected={
                              selectedFilter === ALLCOURSE ? true : false
                           }
                           value="All Courses"
                        />
                     </TouchableOpacity>
                     {/* @Recent */}
                     <TouchableOpacity
                        onPress={() => {
                           setSelectedFilter(RECENT);
                           props.onFilterClick(RECENT);
                        }}>
                        <TabView
                           isSelected={selectedFilter === RECENT ? true : false}
                           value="Recent"
                        />
                     </TouchableOpacity>
                     {/* @In-Session */}
                     {/* <TouchableOpacity
                        onPress={() => {
                           setSelectedFilter(INSESSION);
                           props.onFilterClick(INSESSION);
                        }}>
                        <TabView
                           isSelected={
                              selectedFilter === INSESSION ? true : false
                           }
                           value="In-Session"
                        />
                     </TouchableOpacity> */}

                     {/* @Hide Legacy */}
                     {/* <TouchableOpacity
                        onPress={() => {
                           setSelectedFilter(HIDELEGACY);
                           props.onFilterClick(HIDELEGACY);
                        }}>
                        <TabView
                           isSelected={
                              selectedFilter === HIDELEGACY ? true : false
                           }
                           value=" Hide Legacy"
                        />
                     </TouchableOpacity> */}

                     {/* @Refresh Icon */}
                     {props.showRefreshIcon ? (
                        <View
                           style={{
                              //borderRadius: 20,
                              paddingVertical: 8,
                              //paddingHorizontal: 16,
                              //marginEnd: 4,
                              //height: 32,
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}>
                           <TouchableOpacity
                              onMouseEnter={() => {
                                 setHover(true);
                              }}
                              onMouseLeave={() => {
                                 setHover(false);
                              }}
                              onPress={() => {
                                 //setSelectedFilter(ALLCOURSE);
                                 props.onFilterClick(REFRESH_DASHBOARD);
                              }}>
                              {props.isDashboardRefresh ? (
                                 <RefreshDashBoardView width={32} height={32} />
                              ) : (
                                 <Image
                                    source={require('../../assets/refresh_dashboard2.png')}
                                    style={[
                                       {
                                          width: 32,
                                          height: 32,
                                       },
                                       isHoverEnabled &&
                                          isHover && {opacity: 0.7},
                                    ]}
                                 />
                              )}
                           </TouchableOpacity>
                        </View>
                     ) : null}
                  </View>
               ) : null}
               {props.showRefreshIcon_ ? (
                  <View
                     style={{
                        borderRadius: 100,
                        padding: 5,
                        marginStart: 10,
                        backgroundColor: primaryState700,
                     }}>
                     <TouchableOpacity
                        onPress={() => {
                           setSelectedFilter(ALLCOURSE);
                           props.onFilterClick(ALLCOURSE);
                        }}>
                        <Image
                           source={require('../../assets/refresh_dashboard.png')}
                           style={{width: 14, height: 14}}
                        />
                     </TouchableOpacity>
                  </View>
               ) : null}
            </View>
         ) : null}

         {typeof props.isMyTraning !== 'undefined' ? (
            <View style={styles.headerBottomBackground2}>
               <Text
                  style={{
                     flex: 1,
                     color: gray,
                     fontSize: 10,
                     fontWeight: '600',
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  Course Name
               </Text>
               <View
                  style={{
                     flexDirection: 'row',
                     flex: 0.3,
                     alignItems: 'center',
                  }}>
                  <View
                     style={{
                        height: 12,
                        width: 1,
                        marginRight: 8,
                        backgroundColor: white,
                        opacity: 0.2,
                     }}
                  />
                  <Text
                     style={{
                        color: gray,
                        fontSize: 10,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     Completion Date
                  </Text>
               </View>

               <View
                  style={{
                     flexDirection: 'row',
                     flex: 0.3,
                     alignItems: 'center',
                  }}>
                  <View
                     style={{
                        height: 12,
                        width: 1,
                        marginRight: 8,
                        backgroundColor: white,
                        marginLeft: isWindows ? 16 : null,
                        opacity: 0.2,
                     }}
                  />
                  <Text
                     style={{
                        color: gray,
                        fontSize: 10,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     Expiry
                  </Text>
               </View>

               <View
                  style={{
                     flexDirection: 'row',
                     flex: 0.1,
                     alignItems: 'center',
                  }}>
                  <View
                     style={{
                        height: 12,
                        width: 1,
                        marginRight: 8,
                        backgroundColor: white,
                        opacity: 0.2,
                     }}
                  />

                  <Text
                     style={{
                        color: gray,
                        fontSize: 10,
                        fontWeight: '600',
                        marginLeft: isWindows ? 16 : null,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {selectedRecordFilter === VALID ? 'Valid' : 'All'}
                  </Text>
               </View>
            </View>
         ) : null}

         {validOrientationWeb && (
            <PopoverLandscape
               visible={popoverVisible}
               anchorView={anchorView}
               onclose={() => {
                  setPopoverVisible(false);
               }}
               width={windowDimensions.width}
               height={windowDimensions.height}
               content={
                  <MyTrainingPopup
                     filterMytrainingData={filterText => {
                        setSelectedTrainingRecord(filterText);
                        props.filterMytrainingData(filterText);
                     }}
                     dismissPopover={() => {
                        setPopoverVisible(false);
                     }}
                  />
               }
            />
         )}
         {Platform.OS === 'windows' && (
            <Popup
               isOpen={windowsPopoverVisible}
               isLightDismissEnabled={true}
               target={myRef.current}
               horizontalOffset={-myTraingDrpDownWidth}
               verticalOffset={-10}
               onDismiss={() => {
                  setWindowsPopoverVisible(false);
               }}>
               <MyTrainingPopup
                  filterMytrainingData={filterText => {
                     setSelectedTrainingRecord(filterText);
                     props.filterMytrainingData(filterText);
                  }}
                  dismissPopover={() => {
                     setWindowsPopoverVisible(false);
                  }}
               />
            </Popup>
         )}
      </View>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: appBackground},
   headerTopBackground: {
      backgroundColor: '#021F51',
      paddingHorizontal: 16,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 72,
      width: '100%',
   },
   headerBackground: {
      backgroundColor: '#001231',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
   },
   headerBottomBackground: {
      backgroundColor: primaryColor900,
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerBottomBackground2: {
      backgroundColor: '#000000',
      paddingHorizontal: 16,
      paddingVertical: 6,
      height: 40,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default DashboardHeaderLandsacap;
